import { Button, CloseButton, Heading, Modal } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { ActionTypePanel } from "./ActionTypePanel";

const ActionTypesModal = (props) => {
  const {
    addTypesModalOpen,
    setAddTypesModalOpen,
    handleCloseTypesModal,
    setTypes,
    external,
  } = props;
  const { t } = useTranslation();

  return (
    <Modal
      as="form"
      open={addTypesModalOpen}
      onDismiss={() => {
        setAddTypesModalOpen(false);
      }}
      size="medium"
      label={t("actions.manageActionTypesModalDialog")}
      shouldCloseOnDocumentClick
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={handleCloseTypesModal}
          screenReaderLabel={t("global.close")}
        />
        <Heading as="h3">{t("actions.manageActionTypes")}</Heading>
      </Modal.Header>
      <Modal.Body>
        <ActionTypePanel
          onAssignmentTypesReload={setTypes}
          external={external}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCloseTypesModal} margin="0 x-small 0 0">
          {t("global.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActionTypesModal;
